let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5p1az")).then(() => parcelRequire('68yjx'));